import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import React, { memo } from "react";
import { Link } from "react-router-dom";
import "./PublicRegister.css";

interface TermsAndConditionsProps {
    termsData: { checked: boolean; showError: boolean };
    termsOnChange: () => void;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = memo((props) => {
    const { termsData, termsOnChange } = props;
    const pp = new PublicPortalRoutingService();
    return (
        <Box className={termsData.showError ? "terms-details-container terms-details-container--error" : "terms-details-container"}>
            <Typography variant="body2">
                Login details are confidential and only used to prevent anonymous comments or in the prevention or investigation of fraudulent activity as the law permits. Planning
                services will not share your data with third parties except where necessary to process your comments and preventing or detecting crime.
            </Typography>
            <FormControlLabel
                control={<Checkbox checked={termsData.checked} onChange={termsOnChange} />}
                label={
                    <Link target="_blank" to={pp.TermsAndConditionsRoute()}>
                        I agree to the terms and conditions.
                    </Link>
                }
            />
        </Box>
    );
});

export default TermsAndConditions;
